import {
    ClientAiProfileAiStrategyUpdateEntity,
    ClientAiProfileEntity,
    ClientAiProfileGeneralUpdateEntity,
} from '@/entities/client-ai-profile.entity';
import { EndpointOptions } from '@/types/endpoint.options';
import { getAxiosInstance, withSuppressedErrorToast } from '@/client/get-axios-instance';
import { buildMarketplaceApiPath } from '@/repositories/marketplace-api-paths';

class ClientAiProfileRepository {
    private readonly _axios = getAxiosInstance(buildMarketplaceApiPath('settings/ai-profile'));

    get(options?: EndpointOptions) {
        return this._axios.get<ClientAiProfileEntity>(
            '',
            withSuppressedErrorToast({
                headers: { Authorization: options?.authToken },
                signal: options?.signal,
            }),
        );
    }

    put(data: ClientAiProfileEntity, options?: EndpointOptions) {
        return this._axios.put<ClientAiProfileEntity>('', data, {
            ...withSuppressedErrorToast({
                headers: { Authorization: options?.authToken },
                signal: options?.signal,
            }),
        });
    }

    putGeneral(data: ClientAiProfileGeneralUpdateEntity, options?: EndpointOptions) {
        return this._axios.put<ClientAiProfileEntity>(
            '',
            {
                updateScope: 'general',
                ...data,
            },
            withSuppressedErrorToast({
                headers: { Authorization: options?.authToken },
                signal: options?.signal,
            }),
        );
    }

    putAiStrategy(data: ClientAiProfileAiStrategyUpdateEntity, options?: EndpointOptions) {
        return this._axios.put<ClientAiProfileEntity>(
            '',
            {
                updateScope: 'ai-strategy',
                ...data,
            },
            withSuppressedErrorToast({
                headers: { Authorization: options?.authToken },
                signal: options?.signal,
            }),
        );
    }
}

export const createClientAiProfileRepository = () => new ClientAiProfileRepository();

export const clientAiProfileRepository = createClientAiProfileRepository();
